import React, { useState } from 'react';
import { aiApi, marketApi } from './api';

export default function TradingSignals() {
  const [ticker, setTicker] = useState('AAPL');
  const [price, setPrice] = useState('');
  const [signal, setSignal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [error, setError] = useState(null);

  const useLivePrice = async () => {
    setQuoteLoading(true);
    setError(null);
    try {
      const q = await marketApi.quote(ticker.toUpperCase());
      setPrice(q.price);
    } catch (err) {
      setError(err.message);
    } finally {
      setQuoteLoading(false);
    }
  };

  const fetchSignal = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await aiApi.tradingSignal({ ticker: ticker.toUpperCase(), currentPrice: parseFloat(price) });
      setSignal(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const signalColor = { BUY: '#16a34a', SELL: '#dc2626', HOLD: '#d97706' };

  return (
    <div className="module-container">
      <div className="module-header">
        <h2>Trading Signals</h2>
        <p>AI-powered buy/sell/hold recommendations, seeded from live market price.</p>
      </div>

      <div className="module-content">
        <div className="input-section">
          <div className="input-group">
            <label>Stock Ticker</label>
            <input type="text" value={ticker} onChange={(e) => setTicker(e.target.value.toUpperCase())} maxLength={6} />
          </div>

          <div className="input-group">
            <label>Current Price</label>
            <div className="price-input-row">
              <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="0.00" step="0.01" min="0" />
              <button type="button" className="secondary-button" onClick={useLivePrice} disabled={quoteLoading}>
                {quoteLoading ? 'Fetching…' : 'Use live price'}
              </button>
            </div>
          </div>

          <button onClick={fetchSignal} disabled={loading || !price} className="primary-button">
            {loading ? 'Analyzing…' : 'Get Signal'}
          </button>
        </div>

        {error && <div className="error-box">{error}</div>}

        {signal && (
          <div className="signal-result">
            <div className="signal-badge" style={{ borderColor: signalColor[signal.signal] }}>
              <span className="signal-text" style={{ color: signalColor[signal.signal] }}>{signal.signal}</span>
              <span className="confidence">{signal.confidence}% Confidence</span>
            </div>

            <div className="signal-details">
              <p className="reasoning">{signal.reasoning}</p>
              <div className="metrics-grid">
                <div className="metric">
                  <span className="metric-label">Price Target</span>
                  <span className="metric-value">${signal.priceTarget}</span>
                </div>
                <div className="metric">
                  <span className="metric-label">Risk Level</span>
                  <span className="metric-value">{signal.riskLevel}</span>
                </div>
                {signal.timeframe && (
                  <div className="metric">
                    <span className="metric-label">Timeframe</span>
                    <span className="metric-value">{signal.timeframe}</span>
                  </div>
                )}
              </div>

              {signal.keyMetrics && (
                <div className="key-metrics">
                  <p className="metrics-label">Key Metrics</p>
                  <ul>
                    {signal.keyMetrics.map((metric, idx) => (
                      <li key={idx}>{metric}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
